import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import MobileCustomerStatement from '../../components/AR/mobileCustomerStatement';
import {
  fetchMobileCustomerStatement,
  resetMobileCustomerStatement, 
} from '../../actions/arap_actions';
import { setValue } from '../../actions/sales_actions';

const mobileCustomerStatement = reduxForm({
  form: 'mobileCustomerStatement',
  destroyOnUnmount: true,
})(MobileCustomerStatement);

const selector = formValueSelector('mobileCustomerStatement');

function mapStateToProps(state) {
    const typeRadios = selector(state, 'typeRadios');
    const Year = selector(state, 'Year');
    const Month = selector(state, 'Month');
    const Quarter = selector(state, 'Quarter');
    const FromDate = selector(state, 'FromDate');
    const ToDate = selector(state, 'ToDate');

    const {
      mobileCustomerStatement: {
        months,
        days,
        invoice_amount,
        receive_amount,
        order_amount,
        total_order,
        total_capture,
        total_invoice,
      },
      mobileCustomerStatementError,
      mobileCustomerStatementIsLoading,
    } = state.arap.mobileCustomerStatement;
    const rows = months || days || [];
    const twoDecimalZero = (0).toFixed(2);
    const invoiceAmount = invoice_amount ? parseFloat(invoice_amount).toFixed(2) : twoDecimalZero;
    const receiveAmount = receive_amount ? parseFloat(receive_amount).toFixed(2) : twoDecimalZero;
    const orderAmount = order_amount ? parseFloat(order_amount).toFixed(2) : twoDecimalZero;
    const totalOrders = parseFloat(total_order) || 0;
    const totalCaptured = parseFloat(total_capture) || 0;
    const totalInvoices = parseFloat(total_invoice) || 0;

    return {
        typeRadios,
        Year,
        Month,
        Quarter,
        FromDate,
        ToDate,
        mobileCustomerStatement: {
          mobileCustomerStatementError,
          mobileCustomerStatementIsLoading,
          rows,
          invoiceAmount,
          receiveAmount,
          orderAmount,
          totalOrders,
          totalCaptured,
          totalInvoices,
        },
    };
}

export default connect(mapStateToProps, {
  setDefaultOfForm,
  fetchMobileCustomerStatement,
  resetMobileCustomerStatement,
  setValue,
})(mobileCustomerStatement);



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/mobileCustomerStatement.jsx